/* NordCap scripts for the Odin theme. Loaded with defer after theme.min.js. Built from build/js. */

/* ===== 10-core.js ===== */
;(function () {
'use strict';
/* 10-core.js -- foundation.
   1. Stops the theme's visitor IP lookup (https://ipapi.co/json).
   2. Header: slides out of view on scroll down, comes back on scroll up.

   Load order this file relies on (layout/theme.liquid):
     jquery (blocking, in <head>)  ->  theme.min.js (defer)  ->  nc-theme.js (defer, right after it).
   Deferred scripts run in document order before DOMContentLoaded. theme.min.js only *registers*
   its start-up with jQuery's ready(), and jQuery 2.2.3 fires ready() from DOMContentLoaded
   (it was loaded while the document was still parsing). So everything here runs after the
   theme's functions exist and before theme.init() calls them. */

var doc = document;
var win = window;

/* ---------------------------------------------------------------------------------------------
   1. No IP lookup.
   theme.init() calls theme.getUserLocationData() on every page; the original fetches
   https://ipapi.co/json once per browser session and its only consumers are add-ons that are
   not loaded in this shop. The replacement resolves to null without any request. It is defined
   as an accessor so that it also survives if the theme file were ever evaluated after this one.
   --------------------------------------------------------------------------------------------- */
(function () {
  var theme = win.theme;
  if (!theme || typeof theme !== 'object') { return; }

  var noLookup = function () { return Promise.resolve(null); };

  try {
    Object.defineProperty(theme, 'getUserLocationData', {
      configurable: true,
      enumerable: true,
      get: function () { return noLookup; },
      set: function () { /* keep the replacement */ }
    });
  } catch (err) {
    theme.getUserLocationData = noLookup;
  }
})();

/* ---------------------------------------------------------------------------------------------
   2. Header hides on scroll down, returns on scroll up.
   The theme's own "sticky header" setting keeps the bar pinned with position: sticky (it adds
   the class "sticky-header" to <body>), so the bar keeps its place in the page flow and nothing
   jumps. This code only switches the class "nc-header-hidden" on <body>; nc-theme.css turns
   that into a transform. Sticky setting off = this code does nothing.
   The announcement bar above the header is not sticky: the header is never hidden until the
   page has scrolled past both bars.
   --------------------------------------------------------------------------------------------- */
(function () {
  var body = doc.body;
  if (!body || !body.classList) { return; }

  var HIDDEN = 'nc-header-hidden';
  var TOLERANCE = 6;        // px of travel before a direction counts (finger jitter, momentum tail)
  var header = null;        // #shopify-section-header (the sticky element)
  var keepUntil = 0;        // scroll position up to which the header always stays visible
  var lastY = 0;
  var queued = false;

  function scrollY() {
    var y = win.pageYOffset;
    if (typeof y !== 'number') { y = (doc.documentElement && doc.documentElement.scrollTop) || 0; }
    return y < 0 ? 0 : y;   // iOS rubber band above the top
  }

  function measure() {
    header = doc.getElementById('shopify-section-header');
    var bar = doc.getElementById('shopify-section-announcement');
    keepUntil = (bar ? bar.offsetHeight : 0) + (header ? header.offsetHeight : 0);
  }

  function show() {
    if (body.classList.contains(HIDDEN)) { body.classList.remove(HIDDEN); }
  }

  function hide() {
    if (!body.classList.contains(HIDDEN)) { body.classList.add(HIDDEN); }
  }

  // menu drawer, search drawer, cart drawer and modals all put one of these classes on <body>
  function overlayOpen() {
    return body.classList.contains('js-drawer-open') || body.classList.contains('js-modal-open');
  }

  // an open dropdown inside the header (account menu on desktop)
  function headerBusy() {
    return !!(header && header.querySelector('.dropdown-open'));
  }

  function update() {
    queued = false;

    var y = scrollY();

    if (!header || !body.classList.contains('sticky-header')) {
      show();
      lastY = y;
      return;
    }

    if (overlayOpen() || headerBusy() || y <= keepUntil) {
      show();
      lastY = y;
      return;
    }

    var moved = y - lastY;
    if (moved > -TOLERANCE && moved < TOLERANCE) { return; }   // lastY is kept, so slow travel adds up

    var viewport = win.innerHeight || 0;

    if (viewport && (moved > viewport || moved < -viewport)) {
      // more than a screen in one frame is a jump (scroll position restored after a reload,
      // an anchor link), not a finger: leave the header as it is
      lastY = y;
      return;
    }

    if (moved > 0) {
      hide();
    } else {
      // the bounce at the very end of the page reads as "scrolling up": ignore it
      var root = doc.scrollingElement || doc.documentElement;
      var atEnd = !!root && (y + viewport >= root.scrollHeight - 2);
      if (!atEnd) { show(); }
    }

    lastY = y;
  }

  function onScroll() {
    if (queued) { return; }
    queued = true;
    if (win.requestAnimationFrame) {
      win.requestAnimationFrame(update);
    } else {
      win.setTimeout(update, 16);
    }
  }

  function remeasure() {
    measure();
    onScroll();
  }

  measure();
  lastY = scrollY();

  win.addEventListener('scroll', onScroll, { passive: true });
  win.addEventListener('resize', remeasure);
  win.addEventListener('orientationchange', remeasure);
  win.addEventListener('load', remeasure);                    // web fonts can change the bar heights
  doc.addEventListener('shopify:section:load', remeasure);    // theme editor re-renders the sections

  // keyboard focus moving into a hidden header brings it back
  doc.addEventListener('focusin', function (evt) {
    if (header && evt.target && header.contains(evt.target)) { show(); }
  });

  // a drawer or modal that opens while the header is away (cart drawer after "add to cart")
  if (win.MutationObserver) {
    new win.MutationObserver(function () {
      if (overlayOpen()) { show(); }
    }).observe(body, { attributes: true, attributeFilter: ['class'] });
  }
})();
})();

/* ===== 30-buybox.js ===== */
;(function () {
'use strict';
/* Product page: gallery dots and peek, sticky add-to-cart bar (with the price of the chosen offer), taps inside the bundle box.

   This file only reads the theme's carousel (slick) through its public events and methods and
   never adds anything to the cart itself: the sticky bar presses the product form's own button.
   The switch between theme price / picker and the bundle box is NOT here; it runs inline in
   sections/product-template.liquid so that it also works if this file fails to load. */

var doc = document;
var jq = window.jQuery;

function closest(el, selector) {
  return el && typeof el.closest === 'function' ? el.closest(selector) : null;
}

function setClass(el, name, on) {
  if (el.classList.contains(name) !== on) el.classList[on ? 'add' : 'remove'](name);
}

/* ================= Gallery =================
   Markup: snippets/product-template.liquid ([data-product-single-media-group] is the carousel,
   [data-nc-gallery-dots] its dots). The theme creates the carousel on DOM ready; this file runs
   before that (both are deferred, this one later in the page), so the listeners are in place
   when slick announces "init". If it ever runs later, the current state is read instead. */

function setupGallery(group) {
  if (!jq || !group || group.getAttribute('data-nc-gallery') === 'on') return;
  group.setAttribute('data-nc-gallery', 'on');

  var wrapper = group.parentNode;
  var box = wrapper && wrapper.querySelector ? wrapper.querySelector('[data-nc-gallery-dots]') : null;
  var dots = box ? box.querySelectorAll('[data-nc-dot]') : [];
  var $group = jq(group);

  // index: slide that is, or is about to be, in view
  function show(index, count) {
    index = parseInt(index, 10) || 0;
    count = parseInt(count, 10) || dots.length || 1;
    if (index > count - 1) index = count - 1;
    if (index < 0) index = 0;

    // which neighbour peeks: see build/css/30-buybox.css
    var pos = 'start';
    if (count > 1 && index === count - 1) pos = 'end';
    else if (index > 0) pos = 'mid';
    if (group.getAttribute('data-nc-pos') !== pos) group.setAttribute('data-nc-pos', pos);

    for (var i = 0; i < dots.length; i++) {
      var on = i === index;
      setClass(dots[i], 'nc-is-active', on);
      if (on) dots[i].setAttribute('aria-current', 'true');
      else dots[i].removeAttribute('aria-current');
    }
  }

  function fromSlick(slick) {
    if (slick && typeof slick.slideCount === 'number') show(slick.currentSlide, slick.slideCount);
  }

  // slick fires these as jQuery events on the carousel element; they bubble, so ignore
  // anything that comes from another carousel
  $group.on('init reInit', function (evt, slick) {
    if (evt.target === group) fromSlick(slick);
  });

  $group.on('beforeChange', function (evt, slick, current, next) {
    if (evt.target === group && slick) show(next, slick.slideCount);
  });

  $group.on('afterChange', function (evt, slick, current) {
    if (evt.target === group && slick) show(current, slick.slideCount);
  });

  $group.on('destroy', function (evt) {
    if (evt.target === group) group.removeAttribute('data-nc-pos');
  });

  if (box) {
    box.addEventListener('click', function (evt) {
      var dot = closest(evt.target, '[data-nc-dot]');
      if (!dot) return;
      evt.preventDefault();
      if ($group.hasClass('slick-initialized')) {
        $group.slick('slickGoTo', parseInt(dot.getAttribute('data-nc-dot'), 10) || 0);
      }
    });
  }

  if ($group.hasClass('slick-initialized')) {
    try {
      fromSlick($group.slick('getSlick'));
    } catch (err) { /* carousel not readable: dots keep their server-side state */ }
  }
}

function setupGalleries(scope) {
  var groups = (scope || doc).querySelectorAll('[data-product-single-media-group]');
  for (var i = 0; i < groups.length; i++) setupGallery(groups[i]);
}

/* ================= Sticky add-to-cart bar =================
   Markup: snippets/nc-sticky-atc.liquid. One bar, on the product page only. */

var stickyOff = null; // undoes the listeners of the bar that is currently set up

function setupSticky(bar) {
  if (!bar || bar.getAttribute('data-nc-ready') === '1') return;

  var main = doc.getElementById(bar.getAttribute('data-nc-target') || '');
  var button = bar.querySelector('[data-nc-sticky-btn]');
  var label = bar.querySelector('[data-nc-sticky-label]');
  var price = bar.querySelector('[data-nc-sticky-price]');
  var body = doc.body;
  if (!main || !button || !body) return;

  // the product form the main button submits; the bundle box is mounted inside it
  var form = closest(main, 'form') || closest(main, '.product-single__form');
  // the product section: sections/product-template.liquid marks it "nc-kb-price-off" while the
  // theme's own price is hidden because a bundle offer exists for the product
  var root = closest(main, '[data-section-type="product-template"]');

  // theme editor: the section was drawn again, drop the bar of the earlier drawing
  if (stickyOff) stickyOff();
  var old = body.querySelectorAll('[data-nc-sticky-atc]');
  for (var i = 0; i < old.length; i++) {
    if (old[i] !== bar && old[i].parentNode === body) body.removeChild(old[i]);
  }

  bar.setAttribute('data-nc-ready', '1');

  // out of the page content: <main> is its own stacking layer and would keep the bar under
  // the footer; at the end of <body> "position: fixed" is safe
  body.appendChild(bar);
  bar.hidden = false; // from here on the stylesheet keeps it off screen until .nc-is-visible

  var queued = false;
  var priceQueued = false;
  var observer = null;
  var formObserver = null;

  // the price of the chosen offer as the bundle app last announced it, and for which box
  var announcedPrice = null;
  var announcedBlock = null;

  // copy label and state of the main button
  function mirror() {
    var text = main.querySelector('.btn__add-to-cart-text');
    var value = text ? text.textContent.replace(/\s+/g, ' ').replace(/^ | $/g, '') : '';
    if (label && value && label.textContent !== value) label.textContent = value;

    var off = !!main.disabled || main.classList.contains('disabled');
    if (button.disabled !== off) button.disabled = off;

    setClass(button, 'nc-is-busy', main.classList.contains('btn--loading') || main.classList.contains('nc-upsell-wait'));
  }

  /* ---- Price of the chosen offer ----
     Read, never computed: it is the text the bundle box (Kaching Bundles) prints for its
     selected row, so the bar can only ever show what the buy box shows. It is written only
     when the app's own last announcement for that box ("variants-changed", sent on every
     change of offer or variant with the formatted total) says the same amount: no
     announcement, no price. Any doubt (no selected row, prices hidden, extra text in the
     price cell, the two sources disagree) leaves the bar without a price. Products without a
     bundle box show the theme's own price only when the snippet could print one that cannot
     change (single variant) and only while the theme shows that price itself. */

  // text of the element itself, without its child elements
  function ownText(node) {
    var out = '';
    for (var n = node.firstChild; n; n = n.nextSibling) {
      if (n.nodeType === 3) out += n.nodeValue;
    }
    return out.replace(/\s+/g, ' ').replace(/^ | $/g, '');
  }

  function setPrice(value) {
    if (!price) return;
    value = value || '';
    if (price.textContent !== value) price.textContent = value;
    if (price.hidden !== !value) price.hidden = !value;
    setClass(bar, 'nc-sticky-atc--price', !!value);
  }

  function readPrice() {
    priceQueued = false;
    if (!price) return;

    var block = form ? form.querySelector('kaching-bundles-block') : null;
    if (!block) {
      // no bundle box (yet): the theme's own price, but never while the theme hides it
      // because an offer exists for this product
      var gated = root && root.classList.contains('nc-kb-price-off');
      setPrice(gated ? '' : price.getAttribute('data-nc-static-price') || '');
      return;
    }
    if (block.querySelector('.kaching-bundles__bars--hide-prices')) {
      setPrice('');
      return;
    }

    var chosen = block.querySelector('.kaching-bundles__bar--selected');
    var cell = chosen ? chosen.querySelector('.kaching-bundles__bar-price') : null;
    var shown = cell ? ownText(cell) : '';

    // exactly one amount: an optional short currency sign or 2-3 letter code before or after
    // it, nothing else ("$56.99", "£56.99", "56,99 kr", "$56.99 USD"; not "$28.50 each",
    // "$56.99/ea" or two amounts)
    if (!/^(?:[^\d\sA-Za-z]{1,3}|[A-Za-z]{2,3})?\s?\d[\d.,]*(?:\s?(?:[^\d\sA-Za-z]{1,3}|[A-Za-z]{2,3}))?$/.test(shown)) {
      setPrice('');
      return;
    }
    // and only the amount the app itself announced for this very box
    if (announcedPrice === null || announcedBlock !== block || announcedPrice !== shown) {
      setPrice('');
      return;
    }
    setPrice(shown);
  }

  // a timer, not requestAnimationFrame: the price must also follow the offer while the tab is
  // in the background (browsers pause animation frames there, not timers)
  function queuePrice() {
    if (priceQueued) return;
    priceQueued = true;
    setTimeout(readPrice, 0);
  }

  // the bundle app announces every change on its block element (bubbling, composed)
  function announced(evt) {
    var target = evt.target;
    if (!target || !form || !form.contains(target)) return;
    if (String(target.tagName).toLowerCase() !== 'kaching-bundles-block') return;

    var detail = evt.detail || {};
    var money = detail.pricing && detail.pricing.discountedPrice ? detail.pricing.discountedPrice.formatted : detail.formattedPrice;
    announcedBlock = target;
    // not a string = unknown shape: store a value that can never match a price text
    announcedPrice = typeof money === 'string' ? money.replace(/\s+/g, ' ').replace(/^ | $/g, '') : '';
    queuePrice();
  }

  // height of the pinned header while it covers the top of the screen
  // ("nc-header-hidden": 10-core.js has slid it away on scroll down)
  function stickyHeaderHeight() {
    if (!body.classList.contains('sticky-header') || body.classList.contains('nc-header-hidden')) return 0;
    var header = doc.querySelector('.header-section');
    return header ? header.offsetHeight : 0;
  }

  function showBar(on) {
    if (bar.classList.contains('nc-is-visible') === on) return;
    setClass(bar, 'nc-is-visible', on);
    setClass(body, 'nc-sticky-atc-on', on);
    if (on) doc.documentElement.style.setProperty('--nc-sticky-atc-h', bar.offsetHeight + 'px');
  }

  // shown only when the main button has left the screen at the top
  function update() {
    queued = false;
    var on = false;
    if (main.isConnected !== false && main.offsetParent !== null) {
      on = main.getBoundingClientRect().bottom <= stickyHeaderHeight();
    }
    showBar(on);
  }

  // next animation frame, or within 100 ms if no frame comes (a tab that is not being drawn
  // gets no frames; the bar must still be right the moment it is looked at)
  function queue() {
    if (queued) return;
    queued = true;
    var done = false;
    function run() {
      if (done) return;
      done = true;
      update();
    }
    if (window.requestAnimationFrame) window.requestAnimationFrame(run);
    setTimeout(run, 100);
  }

  function press(evt) {
    evt.preventDefault();
    mirror();
    if (button.disabled) return;
    // the one and only way into the cart: the product form's own button
    main.click();
  }

  button.addEventListener('click', press);
  window.addEventListener('scroll', queue, { passive: true });
  window.addEventListener('resize', queue);
  window.addEventListener('orientationchange', queue);
  window.addEventListener('load', queue);
  window.addEventListener('kaching-bundles-initialized', queue);
  window.addEventListener('kaching-bundles-initialized', queuePrice);
  doc.addEventListener('variants-changed', announced, true);

  if (window.MutationObserver) {
    observer = new MutationObserver(function () {
      mirror();
      queue();
    });
    observer.observe(main, {
      attributes: true,
      attributeFilter: ['class', 'disabled'],
      childList: true,
      characterData: true,
      subtree: true
    });

    // the bundle box is drawn, redrawn and re-marked inside the form; the gate class sits on
    // the section root around it
    if (root || form) {
      formObserver = new MutationObserver(queuePrice);
      formObserver.observe(root || form, {
        attributes: true,
        attributeFilter: ['class'],
        childList: true,
        characterData: true,
        subtree: true
      });
    }
  }

  stickyOff = function () {
    stickyOff = null;
    button.removeEventListener('click', press);
    window.removeEventListener('scroll', queue, { passive: true });
    window.removeEventListener('resize', queue);
    window.removeEventListener('orientationchange', queue);
    window.removeEventListener('load', queue);
    window.removeEventListener('kaching-bundles-initialized', queue);
    window.removeEventListener('kaching-bundles-initialized', queuePrice);
    doc.removeEventListener('variants-changed', announced, true);
    if (observer) observer.disconnect();
    if (formObserver) formObserver.disconnect();
    setClass(body, 'nc-sticky-atc-on', false);
    if (bar.parentNode) bar.parentNode.removeChild(bar);
  };

  mirror();
  queue();
  readPrice();
}

function setupStickyBars(scope) {
  var bars = (scope || doc).querySelectorAll('[data-nc-sticky-atc]');
  for (var i = 0; i < bars.length; i++) {
    if (bars[i].getAttribute('data-nc-ready') !== '1') {
      setupSticky(bars[i]);
      break; // one bar per page
    }
  }
}

/* ================= Taps inside the bundle box on iPhone =================
   On iOS the theme attaches FastClick to <body>. The bundle app marks its elements "needsclick"
   once, when it first sees FastClick; elements it draws later (the variant selects of an offer
   row chosen afterwards) miss the mark. Keep marking them, so taps there stay native.
   Does nothing where FastClick is not loaded. */

function setupTapFix(form) {
  if (!form || !window.MutationObserver || form.getAttribute('data-nc-tapfix') === 'on') return;
  form.setAttribute('data-nc-tapfix', 'on');

  function mark() {
    if (typeof window.FastClick === 'undefined') return;
    var nodes = form.querySelectorAll('.kaching-bundles *:not(.needsclick)');
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].classList) nodes[i].classList.add('needsclick');
    }
  }

  new MutationObserver(mark).observe(form, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class']
  });
}

function setupTapFixes(scope) {
  var forms = (scope || doc).querySelectorAll('.product-single__form');
  for (var i = 0; i < forms.length; i++) setupTapFix(forms[i]);
}

/* ================= Start ================= */

function start(scope) {
  setupGalleries(scope);
  setupStickyBars(scope);
  setupTapFixes(scope);
}

start(doc);

// in case this file was executed before the page was fully read
if (doc.readyState === 'loading') {
  doc.addEventListener('DOMContentLoaded', function () {
    start(doc);
  });
}

// theme editor: a section was drawn again
doc.addEventListener('shopify:section:load', function (evt) {
  start(evt.target && evt.target.querySelectorAll ? evt.target : doc);
});

doc.addEventListener('shopify:section:unload', function (evt) {
  if (stickyOff && evt.target && evt.target.querySelector && evt.target.querySelector('[data-section-type="product-template"]')) {
    stickyOff();
  }
});
})();

/* ===== 35-product-sections.js ===== */
;(function () {
'use strict';
/* Upsell row under the add-to-cart button (snippets/nc-upsell-toggle.liquid).

   When the switch is on and the visitor presses the product form's own add-to-cart button,
   the chosen extra variant is posted to the cart first and the SAME button is then clicked
   again, so the theme's normal add (which Kaching Bundles rewrites) runs exactly once.
   Listeners sit on document, so they keep working when the section is re-rendered. */

var doc = document;
var REQUEST_TIMEOUT = 6000; // ms: never keep the visitor waiting longer than this for the extra product
var REPLAY_GUARD = 1500;    // ms: clicks re-sent by other scripts right after ours are let through

var passing = false;        // true only while our own button.click() is being dispatched
var busy = false;           // an upsell request is on its way
var lastReplay = 0;

function up(el, selector) {
  return el && typeof el.closest === 'function' ? el.closest(selector) : null;
}

function cartAddUrl() {
  var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
  if (typeof root !== 'string' || root.charAt(0) !== '/') root = '/';
  if (root.charAt(root.length - 1) !== '/') root += '/';
  return root + 'cart/add.js';
}

/* ---- variant list inside the row: show the price of the chosen variant ---- */

function showVariant(select) {
  var row = up(select, '[data-nc-extra]');
  var option = select.options[select.selectedIndex];
  if (!row || !option) return;

  var price = row.querySelector('[data-nc-extra-price]');
  var compare = row.querySelector('[data-nc-extra-compare]');
  var priceText = option.getAttribute('data-price');
  var compareText = option.getAttribute('data-compare');

  if (price && priceText) price.textContent = priceText;
  if (compare) {
    compare.textContent = compareText || '';
    compare.hidden = !compareText;
  }
}

doc.addEventListener('change', function (evt) {
  var target = evt.target;
  if (target && typeof target.matches === 'function' && target.matches('[data-nc-extra-select]')) {
    showVariant(target);
  }
});

/* ---- theme editor only: open the FAQ row whose block is selected in the sidebar ---- */

doc.addEventListener('shopify:block:select', function (evt) {
  var target = evt.target;
  if (target && typeof target.matches === 'function' && target.matches('.nc-faq__item')) {
    target.open = true;
  }
});

/* ---- add to cart ---- */

function mainButton(evt) {
  var button = up(evt.target, 'button[type="submit"], input[type="submit"]');
  if (!button || button.disabled) return null;

  var form = button.form;
  if (!form || String(form.getAttribute('action') || '').indexOf('/cart/add') === -1) return null;

  return button;
}

function findRow(button) {
  var form = button.form;
  var row = form.querySelector('[data-nc-extra]');

  if (!row) {
    // tolerate the row sitting next to the form instead of inside it
    var section = up(form, '[data-section-type="product-template"]');
    row = section ? section.querySelector('[data-nc-extra]') : null;
  }

  return row;
}

function chosenVariant(row) {
  var check = row.querySelector('[data-nc-extra-check]');
  if (!check || !check.checked) return null;

  var select = row.querySelector('[data-nc-extra-select]');
  var id = parseInt(select ? select.value : row.getAttribute('data-variant-id'), 10);
  if (!id) return null;

  return { id: id, check: check };
}

/* Always settles, at the latest after REQUEST_TIMEOUT.
   Resolves true when the extra product is in the cart or may be (no answer in time),
   false when it certainly is not (error answer or no connection). */
function addExtra(variantId) {
  return new Promise(function (resolve) {
    var settled = false;
    var controller = typeof AbortController === 'function' ? new AbortController() : null;

    function finish(result) {
      if (settled) return;
      settled = true;
      clearTimeout(timer);
      resolve(result);
    }

    var timer = setTimeout(function () {
      finish(true);
      if (controller) controller.abort();
    }, REQUEST_TIMEOUT);

    var options = {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    };
    if (controller) options.signal = controller.signal;

    var request;
    try {
      request = window.fetch(cartAddUrl(), options);
    } catch (err) {
      finish(false);
      return;
    }

    request.then(
      function (response) { finish(!!(response && response.ok)); },
      function () { finish(false); }
    );
  });
}

function swallow(evt) {
  evt.preventDefault();
  evt.stopImmediatePropagation();
}

doc.addEventListener('click', function (evt) {
  if (passing) return;                                   // our own second click: let the theme handle it
  if (typeof window.fetch !== 'function') return;

  var button = mainButton(evt);
  if (!button) return;

  var row = findRow(button);
  if (!row) return;

  if (busy) {                                            // second tap while the extra product is being added
    swallow(evt);
    return;
  }

  if (Date.now() - lastReplay < REPLAY_GUARD) return;

  var chosen = chosenVariant(row);
  if (!chosen) return;                                   // switch is off: normal add to cart

  swallow(evt);
  busy = true;
  button.classList.add('nc-upsell-wait');
  button.setAttribute('aria-busy', 'true');

  addExtra(chosen.id).then(function (added) {
    // the extra product is (or may be) in the cart: switch off so another press cannot add it twice
    if (added) chosen.check.checked = false;

    busy = false;
    button.classList.remove('nc-upsell-wait');
    button.removeAttribute('aria-busy');

    // whether the extra add worked or not, the main product must still be added
    lastReplay = Date.now();
    passing = true;
    try {
      button.click();
    } finally {
      passing = false;
    }
  });
}, true);

/* ================= FAQ: one answer open at a time =================
   sections/nc-faq.liquid uses <details>; this only closes the other answers of the same list
   when one is opened (section setting "Close the other answers when one opens"). */
document.addEventListener('toggle', function (evt) {
  var item = evt.target;
  if (!item || !item.open || !item.classList || !item.classList.contains('nc-faq__item')) return;
  var list = item.parentNode;
  if (!list || !item.closest || !item.closest('.nc-faq--single')) return;
  var open = list.querySelectorAll('.nc-faq__item[open]');
  for (var i = 0; i < open.length; i++) {
    if (open[i] !== item) open[i].open = false;
  }
}, true);
})();

/* ===== 40-cart.js ===== */
;(function () {
'use strict';
/* Cart upsell (snippets/nc-cart-upsell.liquid) in the cart drawer and on the /cart page.
   The theme injects the cart markup as a string after every cart change, so nothing can be bound to the
   elements themselves: both listeners are delegated on document.
   Add = POST {id, quantity: 1} to cart/add.js, then theme.ajaxCart.update(), the theme's own public call
   that re-renders the drawer and, on /cart, the page (assets/theme.min.js: cartUpdateCallback). */

var UPSELL = '[data-nc-upsell]';
var ADD = '[data-nc-upsell-add]';
var VARIANT = '[data-nc-upsell-variant]';
var ERROR = '[data-nc-upsell-error]';
var BUSY_CLASS = 'nc-is-busy';
var RERENDER_WAIT_MS = 15000;

var adding = false;

function closest(node, selector) {
  return node && typeof node.closest === 'function' ? node.closest(selector) : null;
}

function addUrl() {
  /* "/" on the primary market, e.g. "/en-gb/" on a market that lives in a subfolder */
  var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
  if (typeof root !== 'string' || root.charAt(0) !== '/') root = '/';
  if (root.charAt(root.length - 1) !== '/') root += '/';
  return root + 'cart/add.js';
}

function setBusy(button, on) {
  if (!button) return;
  if (on) {
    button.classList.add(BUSY_CLASS);
    button.setAttribute('aria-busy', 'true');
    button.setAttribute('disabled', 'disabled');
  } else {
    button.classList.remove(BUSY_CLASS);
    button.removeAttribute('aria-busy');
    button.removeAttribute('disabled');
  }
}

function showError(box, button, message) {
  var target = box ? box.querySelector(ERROR) : null;
  if (!target) return;
  target.textContent = message || (button && button.getAttribute('data-error-text')) || 'This item could not be added.';
  target.removeAttribute('hidden');
}

function clearError(box) {
  var target = box ? box.querySelector(ERROR) : null;
  if (!target) return;
  target.textContent = '';
  target.setAttribute('hidden', 'hidden');
}

/* Resolves once the theme has rebuilt the cart. The clicked button belongs to the old markup, so after a
   successful rebuild it is no longer in the document. If the theme never gets there (script missing,
   request lost) the page is reloaded instead: the item is already in the cart at that point. */
function rerenderCart(button) {
  return new Promise(function (resolve) {
    var settled = false;

    function done() {
      if (settled) return;
      settled = true;
      resolve();
    }

    function reload() {
      if (settled) return;
      settled = true;
      window.location.reload();
    }

    var cart = window.theme && window.theme.ajaxCart;

    if (!cart || typeof cart.update !== 'function') {
      reload();
      return;
    }

    window.setTimeout(function () {
      if (button && document.body.contains(button)) {
        reload();
      } else {
        done();
      }
    }, RERENDER_WAIT_MS);

    try {
      cart.update(done);
    } catch (error) {
      reload();
    }
  });
}

document.addEventListener('click', function (event) {
  var button = closest(event.target, ADD);
  if (!button) return;

  event.preventDefault();

  if (adding || button.disabled) return;

  var box = closest(button, UPSELL);
  var select = box ? box.querySelector(VARIANT) : null;
  var id = parseInt(select && select.value ? select.value : button.getAttribute('data-variant-id'), 10);

  if (!id) return;

  adding = true;
  setBusy(button, true);
  clearError(box);

  fetch(addUrl(), {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify({ id: id, quantity: 1 })
  })
    .then(function (response) {
      return response.json().catch(function () {
        return {};
      }).then(function (data) {
        if (!response.ok || (data && data.status && data.status >= 400)) {
          /* Shopify answers a refused add with {status, message, description}; show its own wording */
          var refused = new Error('cart add refused');
          refused.ncText = data && typeof (data.description || data.message) === 'string' ? (data.description || data.message) : '';
          throw refused;
        }
        return data;
      });
    })
    .then(function () {
      return rerenderCart(button);
    })
    .then(function () {
      adding = false;
      setBusy(button, false);
    }, function (error) {
      adding = false;
      setBusy(button, false);
      /* network failures carry no ncText: the neutral text from data-error-text is shown instead */
      showError(box, button, error && error.ncText ? error.ncText : '');
    });
});

/* Variant select: keep the price next to the title in step with the chosen variant. */
document.addEventListener('change', function (event) {
  var select = closest(event.target, VARIANT);
  if (!select) return;

  var box = closest(select, UPSELL);
  var option = select.options ? select.options[select.selectedIndex] : null;
  if (!box || !option) return;

  var price = option.getAttribute('data-price');
  var compare = option.getAttribute('data-compare');
  var priceNode = box.querySelector('[data-nc-upsell-price]');
  var compareNode = box.querySelector('[data-nc-upsell-compare]');

  if (priceNode && price) {
    (priceNode.querySelector('.money') || priceNode).textContent = price;
  }

  if (compareNode) {
    if (compare) {
      (compareNode.querySelector('.money') || compareNode).textContent = compare;
      compareNode.removeAttribute('hidden');
    } else {
      compareNode.setAttribute('hidden', 'hidden');
    }
  }

  clearError(box);
});
})();

/* ===== 50-home.js ===== */
;(function () {
'use strict';
// Dots for the swipeable rows (.nc-swipe) on phones.
// The row itself is plain CSS scroll-snap (build/css/50-home.css) and works without this file;
// this only adds one dot per resting position, marks the current one and scrolls on tap.
// No autoplay, no timers.

var PHONE = '(max-width: 769px)';
var mq = window.matchMedia ? window.matchMedia(PHONE) : null;
var rows = [];
var queued = false;

function itemsOf(row) {
  var out = [];
  for (var i = 0; i < row.children.length; i++) {
    if (row.children[i].classList.contains('grid__item')) out.push(row.children[i]);
  }
  return out;
}

function stepOf(state) {
  return state.items[0].getBoundingClientRect().width || 0;
}

function maxScroll(row) {
  return row.scrollWidth - row.clientWidth;
}

function build(state, count) {
  state.count = count;
  state.dots = [];
  while (state.nav.firstChild) state.nav.removeChild(state.nav.firstChild);
  if (count < 2) {
    state.nav.hidden = true;
    return;
  }
  state.nav.hidden = false;
  for (var i = 0; i < count; i++) {
    var dot = document.createElement('button');
    dot.type = 'button';
    dot.className = 'nc-dots__dot needsclick';
    dot.setAttribute('aria-label', 'Show item ' + (i + 1) + ' of ' + count);
    state.nav.appendChild(dot);
    state.dots.push(dot);
  }
}

function mark(state) {
  if (state.count < 2) return;
  var step = stepOf(state);
  if (!step) return;
  var row = state.row;
  var current = row.scrollLeft >= maxScroll(row) - 2 ? state.count - 1 : Math.round(row.scrollLeft / step);
  current = Math.max(0, Math.min(state.count - 1, current));
  for (var i = 0; i < state.dots.length; i++) {
    if (i === current) {
      state.dots[i].classList.add('is-active');
      state.dots[i].setAttribute('aria-current', 'true');
    } else {
      state.dots[i].classList.remove('is-active');
      state.dots[i].removeAttribute('aria-current');
    }
  }
}

function refresh(state) {
  var step = stepOf(state);
  var max = maxScroll(state.row);
  var count = 1;
  if (mq && mq.matches && step > 0 && max > 4) {
    count = Math.min(state.items.length, Math.round(max / step) + 1);
  }
  if (count !== state.count) build(state, count);
  mark(state);
}

function refreshAll() {
  queued = false;
  rows = rows.filter(function (state) { return document.documentElement.contains(state.row); });
  rows.forEach(refresh);
}

function queueRefresh() {
  if (queued) return;
  queued = true;
  if (window.requestAnimationFrame) window.requestAnimationFrame(refreshAll);
  else window.setTimeout(refreshAll, 50);
}

function setup(row) {
  if (row.ncSwipeReady) return;
  var items = itemsOf(row);
  if (items.length < 2 || !row.parentNode) return;
  row.ncSwipeReady = true;

  var nav = document.createElement('div');
  nav.className = 'nc-dots';
  nav.hidden = true;
  row.parentNode.insertBefore(nav, row.nextSibling);

  var state = { row: row, nav: nav, items: items, dots: [], count: 0, ticking: false };
  rows.push(state);

  row.addEventListener('scroll', function () {
    if (state.ticking) return;
    state.ticking = true;
    var run = function () { state.ticking = false; mark(state); };
    if (window.requestAnimationFrame) window.requestAnimationFrame(run);
    else window.setTimeout(run, 50);
  }, { passive: true });

  nav.addEventListener('click', function (event) {
    var index = state.dots.indexOf(event.target);
    if (index < 0) return;
    var left = index * stepOf(state);
    try {
      row.scrollTo({ left: left, behavior: 'smooth' });
    } catch (error) {
      row.scrollLeft = left;
    }
  });

  refresh(state);
}

function init() {
  var found = document.querySelectorAll('.nc-swipe');
  for (var i = 0; i < found.length; i++) setup(found[i]);
}

function start() {
  init();
  window.addEventListener('resize', queueRefresh);
  window.addEventListener('orientationchange', queueRefresh);
  window.addEventListener('load', queueRefresh);
  if (mq) {
    if (mq.addEventListener) mq.addEventListener('change', queueRefresh);
    else if (mq.addListener) mq.addListener(queueRefresh);
  }
  // theme editor: a section was added or re-rendered
  document.addEventListener('shopify:section:load', function () {
    init();
    queueRefresh();
  });
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
else start();
})();
